import axios from 'axios';

const HTTPClient = axios.create();

// Add token to each request
HTTPClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('authToken');
    if (!config.headers) config.headers = {};
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 Unauthorized responses
HTTPClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      console.warn('Unauthorized! Redirecting to login.', error.response);
      // Clear auth and redirect to login
      sessionStorage.removeItem('authToken');
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default HTTPClient;
